import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { BrowserService } from '../../../services/browser.service';
import { ApiserviceService } from "../../../apiservice.service";
import { FormControl } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { debounceTime } from 'rxjs/operators';
import { CommonfunctionService } from '../../../services/commonfunction.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-sic-results-details',
  templateUrl: './sic-results-details.component.html',
  styleUrls: ['./sic-results-details.component.scss']
})
export class SicResultsDetailsComponent implements OnInit {
  loader: boolean;
  dataSource = [];
  displayedColumns = ['SN', 'Query id', 'Description', 'Count', 'Year', 'SIC date', 'Action'];
  selectedLangCode;
  searchfilter: FormControl;
  selectedYear: string = 'all';
  yearList = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];
  limit: number = 10;
  offset: number = 0;
  queryId: any;
  optionId: any;
  query_name: any = '';
  search_item: any;
  total: number = 0;
  pageIndex: number = 0;


  sortAsc: string = 'false';
  orderBy: string = 'sic_date';
  loaderExcute: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId,
    private activateRoute: ActivatedRoute,
    private router: Router,
    // private browser:BrowserService,
    public api: ApiserviceService,
    private fnc: CommonfunctionService,
    private alert: NotificationService,
  ) {
    this.searchfilter = new FormControl();
    // this.selectedLangCode = this.global.getCurrentLangCode();
    this.getYears(20);
  }

  ngOnInit(): void {
    this.searchfilter.valueChanges.pipe(debounceTime(500)).subscribe(term => {
      term = term.toLowerCase();
      this.reset();
      if (term && term.length) {
        this.search_item = term;
        this.getSicDetails();
      }
      else if (term.length == 0) {
        this.search_item = '';
        this.getSicDetails();
      }
    })
    this.activateRoute.params.subscribe(param => {
      if (param.option_id && param.query_id) {
        this.optionId = param.option_id;
        this.queryId = param.query_id;
        this.getResults();
        this.getSicDetails();
      }
    })
  }

  /**
   * Reset pagination funtion
   */
  reset() {
    this.offset = 0;
    this.pageIndex = 0
  }

  /**
   * this function used to getting query details by query id to show the name of query
   */
  getResults() {

    let url = `sic-queries?id=${this.queryId}&option_id=${this.optionId}`;
    this.api.getGmsData(url).subscribe({
      next: (res: any) => {
        if (res && res.data[0]) {
          this.query_name = res.data[0].name;
        } else {
          this.alert.notify('Data not found given option id or query id', 'warn')
        }
      },
      error: () => { }
    })
  }

  onchangeFilter(event?) {
    if (event) {
      this.orderBy = event?.active.toLowerCase().replace(/ /g,"_");
      if (event?.direction == 'asc') { this.sortAsc = 'true'; }
      else if (event?.direction == 'desc') { this.sortAsc = 'false'; }
    }
    this.reset();
    this.getSicDetails();
  }


  returnVal(element, cols) {
    cols = cols.toLowerCase().split(' ').join('_');
    if (cols == 'sic_date') {
      return this.fnc.formatDateUTC(new Date(element[cols]), true);
    }else if (cols == 'count') {
      return element['diff_count'];
    }
    return element[cols]
  }



  /**
   * This function is used to creating year list
   * @param val val is param
   */
  getYears(val) {
    const currentYear = new Date().getFullYear();
    let years = [];
    let sortedYears = []
    for (let i = 0; i < val; i++) {
      sortedYears.push(currentYear - i);
    }
    sortedYears.sort((a, b) => {
      if (b < a) {
        return -1;
      }
      if (b > a) {
        return 1;
      }
      return 0;
    });
    sortedYears.forEach(element => {
      const temp = {
        name: element,
      }
      years.push(temp);
    });

    this.yearList = years;
  }

  /**
   * This function is used to get query details data
   * @param id
   */
  getSicDetails() {
    let url = `sic-results?option_id=${this.optionId}&query_id=${this.queryId}&limit=${this.limit}&offset=${this.offset}`;
    if (this.search_item) url += `&name=${this.search_item}`;
    if (this.offset == 0) url += `&is_count=true`;

    if (this.sortAsc) url += `&asc=${this.sortAsc}`
    if (this.orderBy) url += `&order_by=${this.orderBy}`
    // this.dataSource = [{"id":1,"option_id":1,"query_id":1,"description":"Units present in estater not in MI","diff_count":100,"year":2022,"details":[{"unit_uid":"UKWTAA7284"},{"unit_uid":"UKWTAA5575"},{"unit_uid":"UKWTAA5572"},{"unit_uid":"UKWTAA5570"},{"unit_uid":"UKWTAA5579"},{"unit_uid":"UKWTAA5973"},{"unit_uid":"UKWTAA5489"},{"unit_uid":"UKWTAA5596"},{"unit_uid":"UKWTAA5554"},{"unit_uid":"UKWTAA5542"},{"unit_uid":"UKWTAA5484"},{"unit_uid":"UKWTAA5974"},{"unit_uid":"UKWTAA5578"},{"unit_uid":"UKWTAA5514"},{"unit_uid":"UKWTAA5576"},{"unit_uid":"UKWTAA5492"},{"unit_uid":"UKWTAA5538"},{"unit_uid":"UKWTAA0344"},{"unit_uid":"UKWTAA5568"},{"unit_uid":"UKWTAA5545"},{"unit_uid":"UKWTAA6739"},{"unit_uid":"UKWTAA5553"},{"unit_uid":"UKWTAA5539"},{"unit_uid":"UKWTAA5574"},{"unit_uid":"UKWTAA5510"},{"unit_uid":"UKWTAA5541"},{"unit_uid":"UKWTAA5350"},{"unit_uid":"UKWTAA5567"},{"unit_uid":"UKWTAA5577"},{"unit_uid":"UKWTAA5555"},{"unit_uid":"UKWTAA5508"},{"unit_uid":"UKWTAA5478"},{"unit_uid":"UKWTAA6734"},{"unit_uid":"UKWTAA5488"},{"unit_uid":"UKWTAA5580"},{"unit_uid":"UKWTAA5509"},{"unit_uid":"UKWTAA0340"},{"unit_uid":"UKWTAA5972"},{"unit_uid":"UKWTAA5486"},{"unit_uid":"UKWTAA5996"},{"unit_uid":"UKWTAA5491"},{"unit_uid":"UKWTAA5496"},{"unit_uid":"UKWTAA6221"},{"unit_uid":"UKWTAA5609"},{"unit_uid":"UKWTAA5547"},{"unit_uid":"UKWTAA5482"},{"unit_uid":"UKWTAA5511"},{"unit_uid":"UKWTAA5515"},{"unit_uid":"UKWTAA5984"},{"unit_uid":"UKWTAA5537"},{"unit_uid":"UKWTAA5544"},{"unit_uid":"UKWTAA5536"},{"unit_uid":"UKWTAA5566"},{"unit_uid":"UKWTAA5549"},{"unit_uid":"UKWTAA5351"},{"unit_uid":"UKWTAA5564"},{"unit_uid":"UKWTAA5548"},{"unit_uid":"UKWTAA5495"},{"unit_uid":"UKWTAA5481"},{"unit_uid":"UKWTAA5975"},{"unit_uid":"UKWTAA5976"},{"unit_uid":"UKWTAA5565"},{"unit_uid":"UKWTAA5479"},{"unit_uid":"UKWTAA5512"},{"unit_uid":"UKWTAA5498"},{"unit_uid":"UKWTAA5581"},{"unit_uid":"UKWTAA5521"},{"unit_uid":"UKWTAA5483"},{"unit_uid":"UKWTAA5494"},{"unit_uid":"UKWTAA5977"},{"unit_uid":"UKWTAA5540"},{"unit_uid":"UKWTAA5556"},{"unit_uid":"UKWTAA5519"},{"unit_uid":"UKWTAA5520"},{"unit_uid":"UKWTAA5480"},{"unit_uid":"UKWTAA5516"},{"unit_uid":"UKWTAA5518"},{"unit_uid":"UKWTAA5513"},{"unit_uid":"UKWTAA5517"},{"unit_uid":"UKWTAA5490"},{"unit_uid":"UKWTAA5499"},{"unit_uid":"UKWTAA5524"},{"unit_uid":"UKWTAA5535"},{"unit_uid":"UKWTAA5352"},{"unit_uid":"UKWTAA5493"},{"unit_uid":"UKWTAA5485"},{"unit_uid":"UKWTAA5487"},{"unit_uid":"UKWTAA5558"},{"unit_uid":"UKWTAA6735"},{"unit_uid":"UKWTAA5557"},{"unit_uid":"UKWTAA5413"},{"unit_uid":"UKWTAA5571"},{"unit_uid":"UKWTAA5497"},{"unit_uid":"UKWTAA5985"},{"unit_uid":"UKWTAA0336"},{"unit_uid":"UKWTAA5569"},{"unit_uid":"UKWTAA5563"},{"unit_uid":"UKWTAA5573"},{"unit_uid":"UKWTAA5550"},{"unit_uid":"UKWTAA5543"}],"sic_date":"2023-06-27T20:19:20.287587"}]
    this.loader = true;
    this.api.getGmsData(url)
      .subscribe({
        next: (res: any) => {
          this.loader = false;
          if (this.offset == 0) {
            this.total = res?.totalRecord
          }
          if (res && res.data) {
            this.dataSource = typeof(res.data) == 'string' ? JSON.parse(res.data): res.data;
          } else {
            this.dataSource = [];
          }

        },
        error: () => {
          this.loader = false;
          this.dataSource = [];
        }
      })
  }

  /**
   * This function is used to back query page
   */
  backtoquery() {
    this.router.navigate([`/admin/sic-results`]);
  }

  download(data: any) {
    if (data?.details && data?.details.length) {
      let header = Object.keys(data.details[0])
      let h1 = data.description;
      let h2 = `Count - ${data.diff_count} | Year - ${data?.year}`
      let details_list = data.details;
      let key=header[0];
      if(key == 'parcel_uid'){
        details_list.sort(function(a, b) { return a[key].localeCompare(b[key]); });
      }
      this.downloadFile(details_list, `sic_details_${this.queryId}_${data?.year}`, h1, h2, header);
    } else {
      this.alert.notify('Details not available', 'warn');
    }
  }



  /**
   * This function is to download prepared uploaded parcel data

   * @returns void
   */
  downloadFile(data, filename = 'data', header, h2, h3) { 
    if (isPlatformBrowser(this.platformId)) {
      let csvData = this.ConvertToCSV(data, header, h2, h3);
      let blob = new Blob(['\ufeff' + csvData], {
        type: 'text/csv;charset=utf-8;',
      });
      let dwldLink = document.createElement('a');
      let url = URL.createObjectURL(blob);
      let isSafariBrowser =
        navigator.userAgent.indexOf('Safari') != -1 &&
        navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {
        //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute('target', '_blank');
      }
      dwldLink.setAttribute('href', url);
      dwldLink.setAttribute('download', filename + '.csv');
      dwldLink.style.visibility = 'hidden';
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    }
  }
  /**
   * This function is to convert uploaded parcel data for download to csv format

   * @param objArray @type {Array} - An array of object to be converted to csv
   * @param headerList @type {Array} - An array of header to be converted to csv
   * @returns string
   */
  ConvertToCSV(objArray, headerList, h2, h3) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    str += headerList + '\r\n';
    str += h2 + '\r\n';
    for (let index in h3) {
      row += h3[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in h3) {
        let head = h3[index];
        line += array[i][head] + ',';
      }
      str += line + '\r\n';
    }
    return str;
  }

  /**
   * This is a fuction to use execute year wise SIC check
   * sync_type I or C --- I is incrimental , C is complete
   */
  execute() {
    if (this.selectedYear != 'all') {
      this.loaderExcute = true;
      this.api.getGmsData(`sic-exec?query_id=${this.queryId}&year=${this.selectedYear}`).subscribe({
        next: (res: any) => {
          if (res) {
            this.alert.notify("Execution request submitted", 'success');
            this.loaderExcute = false;
            this.getSicDetails();
          } else {
            this.loaderExcute = false;
            this.alert.notify("Execution failed", 'warn');
          }
        },
        error: () => {
          this.loaderExcute = false;
        }
      })
      setTimeout(() => {
        this.getSicDetails();
      }, 2000);
    } else {
      this.alert.notify('Please select year', 'warn');
    }
  }

}
